import React from 'react'

export const NotificationIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="#E0F5E2" />
      <path
        d="M18.1163 14.0753L17.283 12.692C17.108 12.3837 16.9496 11.8003 16.9496 11.4587V9.35033C16.9496 7.39199 15.7996 5.70033 14.1413 4.90866C13.708 4.14199 12.908 3.66699 11.9913 3.66699C11.083 3.66699 10.2663 4.15866 9.83296 4.93366C8.20796 5.74199 7.08296 7.41699 7.08296 9.35033V11.4587C7.08296 11.8003 6.92463 12.3837 6.74963 12.6837L5.90796 14.0753C5.57463 14.6337 5.49963 15.2503 5.70796 15.817C5.90796 16.3753 6.38296 16.8087 6.99963 17.017C8.61629 17.567 10.3163 17.8337 12.0163 17.8337C13.7163 17.8337 15.4163 17.567 17.033 17.0253C17.6163 16.8337 18.0663 16.392 18.283 15.817C18.4996 15.242 18.4413 14.6087 18.1163 14.0753Z"
        fill="#04B115"
      />
      <path
        d="M14.3587 18.6753C14.0087 19.642 13.0837 20.3337 12.0004 20.3337C11.3421 20.3337 10.6921 20.067 10.2337 19.592C9.96706 19.342 9.76706 19.0087 9.65039 18.667C9.75872 18.6837 9.86706 18.692 9.98372 18.7087C10.1754 18.7337 10.3754 18.7587 10.5754 18.7753C11.0504 18.817 11.5337 18.842 12.0171 18.842C12.4921 18.842 12.9671 18.817 13.4337 18.7753C13.6087 18.7587 13.7837 18.7503 13.9504 18.7253C14.0837 18.7087 14.2171 18.692 14.3587 18.6753Z"
        fill="#04B115"
      />
      <circle cx="17" cy="7" r="3" fill="#004360" />
    </svg>
  )
}
